import Phaser from 'phaser';

/**
 * Generates two procedural canvas textures the floor uses for its
 * admin-login-language background:
 *   - `lobby-stripe`: 16×16 tile with a 2 px @ 10%-alpha black band at the
 *     top row. The lobby renders it as a TileSprite rotated −45° so the
 *     band sweeps upper-left → lower-right.
 *   - `lobby-glow`: 512×512 radial gradient, gold at 10% alpha falling off
 *     by 55%. Pinned at the top center of the viewport.
 *
 * Generated once at boot so we don't pay the canvas-fill cost on every
 * LobbyScene.create() (the scene restarts on each return-to-floor).
 */
export class LobbyBootScene extends Phaser.Scene {
  constructor() { super('LobbyBootScene'); }
  preload() {
    if (!this.textures.exists('lobby-stripe')) {
      const stripe = this.textures.createCanvas('lobby-stripe', 16, 16);
      if (stripe) {
        const ctx = stripe.context;
        ctx.clearRect(0, 0, 16, 16);
        ctx.fillStyle = 'rgba(0,0,0,0.10)';
        ctx.fillRect(0, 0, 16, 2);
        stripe.refresh();
      }
    }

    if (!this.textures.exists('lobby-hairline')) {
      // Horizontal hairline used to flank the room-divider pills. The
      // gradient fades from transparent at the ends through gold@65% in
      // the middle, mirroring the admin's room-rule pseudo-element rules.
      // 4 px tall so a 1–2 px display size still picks up the peak alpha
      // after the renderer's bilinear sampling.
      const HW = 256, HH = 4;
      const hairline = this.textures.createCanvas('lobby-hairline', HW, HH);
      if (hairline) {
        const ctx = hairline.context;
        ctx.clearRect(0, 0, HW, HH);
        const grad = ctx.createLinearGradient(0, 0, HW, 0);
        grad.addColorStop(0,   'rgba(212,175,55,0)');
        grad.addColorStop(0.5, 'rgba(212,175,55,0.65)');
        grad.addColorStop(1,   'rgba(212,175,55,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, HW, HH);
        hairline.refresh();
      }
    }

    if (!this.textures.exists('lobby-glow')) {
      const R = 256;
      const glow = this.textures.createCanvas('lobby-glow', R * 2, R * 2);
      if (glow) {
        const ctx = glow.context;
        ctx.clearRect(0, 0, R * 2, R * 2);
        const grad = ctx.createRadialGradient(R, R, 0, R, R, R);
        grad.addColorStop(0,    'rgba(212,175,55,0.10)');
        grad.addColorStop(0.55, 'rgba(212,175,55,0)');
        grad.addColorStop(1,    'rgba(212,175,55,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, R * 2, R * 2);
        glow.refresh();
      }
    }
  }
  create() {
    this.scene.start('LobbyScene');
  }
}
